function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Button from "@material-ui/core/Button";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { connect } from "react-redux";
import { closeModal, getFilteredLiveChannels, openModal, openPinModal, setLiveChannelsLayout, setProfileSettings } from "@common/actions";
import AudioSubtitlesSettings from "@common/components/Settings/AudioSubtitlesSettings";
import ChangeView from "@common/components/Settings/ChangeView";
import ChannelsSetting from "@common/components/Settings/ChannelsSetting";
import ParentalControl from "@common/components/Settings/ParentalControl";
import ResetSettings from "@common/components/Settings/ResetSettings";
import VideoSettings from "@common/components/Settings/VideoSettings";
import SideBarMenu from "@common/components/SideBarMenu";
import Modal from "@common/components/Modal";
import Spinner from "@common/components/Spinner";
import { SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_SUCCESS } from "@config/constants";
import { isEqual } from "lodash";
var Settings = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Settings, Component);
    var _super = _create_super(Settings);
    function Settings(props) {
        _class_call_check(this, Settings);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "diffWebSettings", function() {
            var profileSettings = _this.props.profileSettings;
            return JSON.stringify(_this.state.newProfileSettings.web_settings) === JSON.stringify(profileSettings.web_settings);
        });
        _define_property(_assert_this_initialized(_this), "renderModalFooter", function() {
            var i18n = _this.props.i18n;
            // Avoid saving when no new settings are set
            var disabled = _this.diffWebSettings();
            var renderButton = function() {
                var saveButton = _this.state.saveButton;
                if (_this.state.saveButton) {
                    var _this1 = _assert_this_initialized(_this);
                    // Merge originial button props with the new comming button
                    return /*#__PURE__*/ React.cloneElement(saveButton, _object_spread_props(_object_spread({
                        disabled: disabled,
                        className: "button raised",
                        children: /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "icon icon-save"
                                }),
                                i18n.account.save
                            ]
                        })
                    }, saveButton.props), {
                        onClick: /*#__PURE__*/ _async_to_generator(function() {
                            var onFinish, _tmp;
                            return _ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _this1.setState({
                                            savingSettings: true
                                        });
                                        return [
                                            4,
                                            _this1.saveProfileSettings()
                                        ];
                                    case 1:
                                        _state.sent();
                                        onFinish = saveButton.props.onClick;
                                        if (!(onFinish && onFinish.constructor.name === "AsyncFunction")) return [
                                            3,
                                            3
                                        ];
                                        return [
                                            4,
                                            onFinish()
                                        ];
                                    case 2:
                                        _tmp = _state.sent();
                                        return [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        _tmp = onFinish();
                                        _state.label = 4;
                                    case 4:
                                        _tmp;
                                        _this1.setState({
                                            savingSettings: false
                                        });
                                        return [
                                            2
                                        ];
                                }
                            });
                        })
                    }));
                }
                return /*#__PURE__*/ _jsxs(Button, {
                    disabled: disabled,
                    className: "button raised",
                    onClick: _this.saveProfileSettings,
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "icon icon-save"
                        }),
                        i18n.account.save
                    ]
                });
            };
            var renderLoadingButton = function() {
                return /*#__PURE__*/ _jsx(Button, {
                    className: "button raised",
                    children: /*#__PURE__*/ _jsx(Spinner, {})
                });
            };
            var renderDefaultButton = function() {
                return /*#__PURE__*/ _jsxs(React.Fragment, {
                    children: [
                        _this.state.footerComponent || /*#__PURE__*/ _jsx("span", {}),
                        !_this.state.savingSettings ? renderButton() : renderLoadingButton()
                    ]
                });
            };
            return /*#__PURE__*/ _jsx("div", {
                className: "modal-footer",
                children: renderDefaultButton()
            });
        });
        _define_property(_assert_this_initialized(_this), "handleChangeSettings", function(newProfileSettings, shouldRequirePin) {
            _this.setState({
                newProfileSettings: newProfileSettings,
                shouldRequirePin: shouldRequirePin
            });
        });
        _define_property(_assert_this_initialized(_this), "handleDiscardChanges", function() {
            _this.setState({
                newProfileSettings: _this.props.profileSettings
            });
        });
        var _this1 = _assert_this_initialized(_this);
        _define_property(_assert_this_initialized(_this), "handleStoreUpdate", /*#__PURE__*/ _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this1.props.getFilteredLiveChannels()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        }));
        _define_property(_assert_this_initialized(_this), "getFooterComponents", function() {
            var leftSide = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, saveButton = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
            _this.setState({
                footerComponent: leftSide,
                saveButton: saveButton
            });
        });
        _define_property(_assert_this_initialized(_this), "successSnackbar", function() {
            return _this.props.enqueueSnackbar(_this.props.i18n.settings.changeSettingsSuccess, {
                variant: SNACKBAR_VARIANT_SUCCESS,
                autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
            });
        });
        _define_property(_assert_this_initialized(_this), "handleParentalLockChanges", function(onFinish) {
            var activeComponentName = _this.state.activeComponentName;
            var _this_props = _this.props, _$openModal = _this_props.openModal, _$openPinModal = _this_props.openPinModal;
            var onSuccess = function() {
                var _ref = _async_to_generator(function() {
                    var _tmp;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(onFinish.constructor.name === "AsyncFunction")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    onFinish()
                                ];
                            case 1:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                _tmp = onFinish();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                // Reopen settings again
                // openModal(SETTINGS, { activeComponentName })
                });
                return function onSuccess() {
                    return _ref.apply(this, arguments);
                };
            }();
            _$openPinModal({
                onSuccess: onSuccess,
                shouldShowSnackbar: false,
                shouldUnlock: false
            });
        });
        var _this2 = _assert_this_initialized(_this);
        _define_property(_assert_this_initialized(_this), "saveProfileSettings", /*#__PURE__*/ _async_to_generator(function() {
            var _$setProfileSettings, shouldRequirePin, newProfileSettings, equal, onFinish, _tmp;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _$setProfileSettings = _this2.props.setProfileSettings;
                        shouldRequirePin = _this2.state.shouldRequirePin;
                        newProfileSettings = _object_spread({}, _this2.state.newProfileSettings);
                        equal = JSON.stringify(newProfileSettings.web_settings) === JSON.stringify(_this2.props.profileSettings.web_settings);
                        if (equal) {
                            return [
                                2
                            ];
                        }
                        onFinish = function() {
                            var _ref = _async_to_generator(function() {
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                _$setProfileSettings(newProfileSettings)
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                4,
                                                _this2.handleStoreUpdate()
                                            ];
                                        case 2:
                                            _state.sent();
                                            _this2.successSnackbar();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function onFinish() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        if (!shouldRequirePin) return [
                            3,
                            1
                        ];
                        _tmp = _this2.handleParentalLockChanges(onFinish);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            onFinish()
                        ];
                    case 2:
                        _tmp = _state.sent();
                        _state.label = 3;
                    case 3:
                        _tmp;
                        return [
                            2
                        ];
                }
            });
        }));
        _this.state = {
            activeComponentName: _this.props.activeComponentName,
            savingSettings: false,
            footerComponent: null,
            saveButton: null,
            newProfileSettings: _this.props.profileSettings,
            shouldRequirePin: false
        };
        _this.toggleComponent = _this.toggleComponent.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(Settings, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                // Make sure we use the latest profileSettings
                if (!isEqual(prevProps.profileSettings, this.props.profileSettings)) {
                    this.setState({
                        newProfileSettings: this.props.profileSettings
                    });
                }
            }
        },
        {
            /**
     *  Toggle the active component by setting its name as activeComponentName
     *  which is then mapped to COMPONENT_MAP component objects
     *  @param {string} component
     */ key: "toggleComponent",
            value: function toggleComponent(component) {
                // Remove footerComponent so it can be updated next
                this.setState({
                    activeComponentName: component,
                    footerComponent: null
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var i18n = this.props.i18n;
                // here we describe every component in the box specification modal
                // and from this map we get the component that is toggled
                //
                // Every component has a 'onChangeHandler' callback
                // which has as function parameter the new settings
                var COMPONENT_MAP = {
                    ChannelsSetting: {
                        component: ChannelsSetting,
                        componentName: "ChannelsSetting",
                        iconClassNames: "isa-icon isa_channels",
                        title: i18n.settings.channelsView,
                        props: {}
                    },
                    AudioSubtitlesSettings: {
                        component: AudioSubtitlesSettings,
                        componentName: "AudioSubtitlesSettings",
                        iconClassNames: "isa-icon isa_subtitles",
                        title: i18n.settings.AudioSubView,
                        props: {}
                    },
                    VideoSettings: {
                        component: VideoSettings,
                        componentName: "VideoSettings",
                        iconClassNames: "isa-icon isa_video",
                        title: i18n.settings.videoView,
                        props: {}
                    },
                    ParentalControl: {
                        component: ParentalControl,
                        componentName: "ParentalControl",
                        iconClassNames: "isa-icon isa_parental",
                        title: i18n.settings.ParentalControlShort,
                        props: {}
                    },
                    ChangeView: {
                        component: ChangeView,
                        componentName: "ChangeView",
                        iconClassNames: "isa-icon isa_theme",
                        title: i18n.settings.changeView,
                        props: {}
                    },
                    ResetSettings: {
                        component: ResetSettings,
                        componentName: "ResetSettings",
                        iconClassNames: "isa-icon isa_reset",
                        title: i18n.settings.ResetView,
                        props: {}
                    }
                };
                // Here we pass configuration data for the sidebar menu
                // Making tabs from the components we need
                var sideMenuTabs = Object.values(COMPONENT_MAP);
                // If there is no specified component to be opened, selects the first one from the tabs menu
                var activeComponentName = this.state.activeComponentName || sideMenuTabs[0].componentName;
                var ActiveComponentObject = COMPONENT_MAP[activeComponentName];
                var iconClassNames = ActiveComponentObject.iconClassNames;
                var title = ActiveComponentObject.title;
                var componentProps = ActiveComponentObject.props || {};
                var _$Component = ActiveComponentObject.component;
                return /*#__PURE__*/ _jsxs(Modal, {
                    title: i18n.settings.modalTitle,
                    children: [
                        /*#__PURE__*/ _jsx(SideBarMenu, {
                            sideMenuTabs: sideMenuTabs,
                            componentMap: COMPONENT_MAP,
                            toggleComponent: this.toggleComponent,
                            activeTabIndex: sideMenuTabs.findIndex(function(e) {
                                return e.componentName === activeComponentName;
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "active-section-title",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: iconClassNames
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    children: title
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "account-content float-right",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "settings-modal-main-wrapper",
                                children: [
                                    /*#__PURE__*/ _jsx(_$Component, _object_spread_props(_object_spread({}, componentProps), {
                                        onChangeHandler: this.handleChangeSettings,
                                        onDiscardChanges: this.handleDiscardChanges,
                                        getFooterComponents: this.getFooterComponents,
                                        activeComponentName: activeComponentName
                                    })),
                                    this.renderModalFooter()
                                ]
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return Settings;
}(Component);
var mapStateToProps = function(param) {
    var i18n = param.i18n, profileSettings = param.profileSettings;
    return {
        i18n: i18n,
        profileSettings: profileSettings
    };
};
var mapDispathToProps = {
    openModal: openModal,
    openPinModal: openPinModal,
    closeModal: closeModal,
    setLiveChannelsLayout: setLiveChannelsLayout,
    setProfileSettings: setProfileSettings,
    getFilteredLiveChannels: getFilteredLiveChannels
};
export default withSnackbar(connect(mapStateToProps, mapDispathToProps)(Settings));
